import classNames from "classnames";
import { AccountSearchResult, CallContext } from "../../../lib/api/models";
import {
  useIsAgentRoleUSA,
  useIsAgentRoleIndia,
} from "../../../lib/roleContext";
import { paths } from "../../../lib/router";
import StyledLinkButton from "../../common/buttons/StyledLinkButton";
import StyledButton from "../../common/buttons/StyledButton";
import styles from "./AccountFound.module.css";

const strings = {
  account: (dwbuid: string) => `Account ${dwbuid}`,
  viewAccount: "View Account",
  viewSecureMail: "View SecureMail",
};

type Props = {
  account: AccountSearchResult;
  className?: string;
  titleClassName?: string;
  dwbuid: string;
  callContext: CallContext | null;
};

function AccountFound({
  account,
  className,
  titleClassName,
  dwbuid,
  callContext,
}: Props) {
  const usaRole = useIsAgentRoleUSA();
  const indiaRole = useIsAgentRoleIndia();
  const canViewSecureMail = usaRole || indiaRole;

  const secureMailButton = () => {
    if (!canViewSecureMail) {
      return null;
    }
    if (account?.registrationDateTime) {
      return (
        <StyledLinkButton
          className={styles.linkButton}
          to={paths.accountSecureMail(dwbuid)}
        >
          {strings.viewSecureMail}
        </StyledLinkButton>
      );
    }
    return (
      <StyledButton
        className={styles.linkButton}
        disabled={!account?.registrationDateTime}
      >
        {strings.viewSecureMail}
      </StyledButton>
    );
  };

  return (
    <div className={classNames(styles.container, className)}>
      <h2 className={classNames(styles.account, titleClassName)}>
        {strings.account(dwbuid)}
      </h2>
      <StyledLinkButton
        className={styles.linkButton}
        to={paths.accountDetails(dwbuid)}
        state={callContext ? { callContext: { ...callContext, dwbuid } } : null}
      >
        {strings.viewAccount}
      </StyledLinkButton>
      {secureMailButton()}
    </div>
  );
}
export default AccountFound;
